import axios from 'axios';
import { Message } from 'element-ui';

let base = '//api.yongtengyc.com/admin';

const axiosInstance = axios.create({
  baseURL: base,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    Message.error({
      message: error.response.data.message || error,
    });
    if (error.response.status === 401) {
      if (~navigator.userAgent.indexOf('MicroMessenger')) {
        const ref = `/wechat-login?next=${encodeURIComponent(
          location.href,
        )}`;
        location.href = ref;
      } else {
        location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export const requestLogin = params => {
  return axiosInstance.post(`${base}/login`, params);
};

export const adminApi = {
  list: params =>
    axiosInstance.get('/list', {
      params,
    }),
  add: data => axiosInstance.post('/create', data),
  del: data => axiosInstance.post('/delete', data),
  update: data => axiosInstance.post('/update', data),
};

export const hotelApi = {
  list: params =>
    axiosInstance.get('/hotel/list', {
      params,
    }),
  add: data => axiosInstance.post('/hotel/create', data),
  del: data => axiosInstance.post('/hotel/delete', data),
  listMap: _ => axiosInstance.get('/hotel/map'),
  update: data => axiosInstance.post('/hotel/update', data),
};

export const auditApi = {
  list: params =>
    axiosInstance.get('/audit/list', {
      params,
    }),
  update: data => axiosInstance.post('/audit/update', data),
  del: data => axiosInstance.post('/audit/delete', data),
};

export const orderApi = {
  list: params => axiosInstance.get('/order/list', { params }),
  cookie: ({ key, cookie }) =>
    axiosInstance.post('/order/update-cookie', { key, cookie: cookie.replaceAll(' ','') }),
  update: data => axiosInstance.post('/order/update', data),
  send: data => axiosInstance.post(`/order/send`, data),
  statistics: params => axiosInstance.get('/order/statistics', { params }),
  settleList: params => axiosInstance.get('/order/settle', { params }),
  settle: data => axiosInstance.post(`/order/settle`, data),
  settlingOrder: params =>
    axiosInstance.get('/order/settling-order', { params }),
  createOrder: data => axiosInstance.post('/order/create', data),
  delete: id => axiosInstance.post(`/order/delete/${id}`),
  tplAdd: data=>axiosInstance.post('/order/tpl-add', data),
  tplDelete: id => axiosInstance.post(`/order/tpl-delete`, {id}),
  tplUpdate: data => axiosInstance.post('/order/tpl-update', data),
  tplList: params => axiosInstance.get('/order/tpl-list', { params }),
  check: params =>  axiosInstance.post('/order/tpl-check', params),
  batchDelete: d=> axiosInstance.post('/order/tpl-batch-delete', d),
  batchEdit: d=> axiosInstance.post('/order/tpl-batch-edit-price', d),
};

export const wxLogin = code => axiosInstance.post('/wx-login', { code });



// WEBPACK FOOTER //
// ./src/api/api.js